import type { SpellIssue } from '../types/spell-issue'
import type { SpellUnderlineRange } from '../types/spell-underline-range'

/**
 * Where to draw underlines: the misspelled words still open, grouped by the text frame that holds
 * them and in reading order within each frame. A word that was ignored, changed or added to the
 * dictionary is not underlined. Text on a path has no text frame to draw on, and an instance
 * without a recorded position cannot be placed, so both are left out.
 */
export function underlineRangesByShape(
  issues: SpellIssue[]
): Map<string, readonly SpellUnderlineRange[]> {
  const byShape = new Map<string, SpellUnderlineRange[]>()

  for (const issue of issues) {
    for (const { status, shapeId, start, end, onPath } of issue.occurrences) {
      if (status !== 'open' || onPath || shapeId === undefined) continue
      if (start === undefined || end === undefined || end <= start) continue

      const ranges = byShape.get(shapeId)

      if (ranges) {
        ranges.push({ start, end })
      } else {
        byShape.set(shapeId, [{ start, end }])
      }
    }
  }

  byShape.forEach((ranges) => ranges.sort((a, b) => a.start - b.start))

  return byShape
}
